<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>

export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true,
    };
  },
  mounted() {
    console.log("app -=== this.$route",this.$route)
    let _url = this.$route.path.split("/e-sign/api/")[1] || "";
    console.log("app_url",_url)
    let _eId = _url.split(".html")[0] || "";
    console.log("app__eId",_eId)
    if(!this.$route.name){
      this.$router.push({
        // path: '/index',
        name: 'index',
        params: {
          key:_eId
        }
      });
    }
  },
};
</script>

<style>
body,*{padding: 0; margin: 0; height: 100%}
iframe{
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue